<template>
  <TimeClock :client-id="clientId" :hideTitle="true" />
</template>

<script>
import { mapActions } from "vuex";
import TimeClock from "src/views/Pages/TimeClock";
export default {
  props: {
    clientId: Number,
  },

  components: {
    TimeClock,
  },

  methods: {
    ...mapActions({
      getAll: "timeclock/getAll",
    }),

    async refresh() {
      await this.getAll();
    },
  },
};
</script>